import { render, staticRenderFns } from "./EtiquetaPequena.vue?vue&type=template&id=731d386c&scoped=true&"
import script from "./EtiquetaPequena.vue?vue&type=script&lang=ts&"
export * from "./EtiquetaPequena.vue?vue&type=script&lang=ts&"
import style0 from "./EtiquetaPequena.vue?vue&type=style&index=0&id=731d386c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731d386c",
  null
  
)

export default component.exports